import moment from 'moment';
import { deliveryDateToReport } from '../../../../../core/models/dashboard/data-utilization-dad.model';

export const deliveryDate = {
    searchText: '',
    addText: '',
    export: true,
    exportFile: 'Fecha_de_TRX_de_entrega_vs_fecha_entrega real.xlsx',
    expandable: true,
    filter: false,
    paginator: true,
    filterDefault: '',
    disabled: false,
    partialField: '',
    columns: [
      {
        title: 'ID',
        name: 'id',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center w130',
        value: (element: deliveryDateToReport) => element.id
      },
      {
        title: 'ID. de la nota de venta',
        name: 'saleNoteId',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: deliveryDateToReport) => element.saleNoteId
      },
      {
        title: 'Compañía',
        name: 'companyCode',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: deliveryDateToReport) => element.companyCode
      },
      {
        title: 'Código de tipo de entrega',
        name: 'deliveryTypeCode',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: deliveryDateToReport) => element.deliveryTypeCode
      },
      {
        title: 'Tipo de origen',
        name: 'originType',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: deliveryDateToReport) => element.originType
      },
      {
        title: 'Descripción actualizada',
        name: 'delayDispatchDateUpdatedDescription',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: deliveryDateToReport) => element.delayDispatchDateUpdatedDescription
      },
      {
        title: 'Fecha de entrega',
        name: 'deliveryDate',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: deliveryDateToReport) => moment(element.deliveryDate).format('YYYY-MM-DD')
      },
      {
        title: 'Total',
        name: 'total',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: deliveryDateToReport) => element.total
      }
    ],
    subTable: {}
  };
